
export default {
    data () {
        return {
            loading: false,
            searchQuery: '',
            groups: [],
            stats: {
                total_groups: null,
                total_clients: null,
                total_with_active_products: null,
            },
            tableFields: [
                { key: 'name', label: 'Group', sortable: true },
                { key: 'total_clients', label: 'Clients', sortable: true },
                { key: 'clients_with_active_products', label: 'With Active Products', sortable: true },
                { key: 'actions', label: '', sortable: false },
            ],
        }
    },
    computed: {
        filteredGroups () {
            if (!this.searchQuery) return this.groups
            const q = this.searchQuery.toLowerCase()
            return this.groups.filter(g => g.name.toLowerCase().includes(q))
        },
        activeGroups () {
            return this.groups.filter(g => g.active).length
        },
    },
    async mounted () {
        await this.loadBrokerGroups()
    },
    methods: {
        async loadBrokerGroups () {
            this.loading = true
            try {
                const res = await this.$api.getBrokerGroups()
                this.groups = res.groups || []
                this.stats = res.stats || this.stats
            } catch (e) {
                console.error('Failed to load broker groups:', e)
            }
            this.loading = false
        },
        stat (val) {
            return val != null ? val : '—'
        },
    },
}
